import React from "react";
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Paper
} from '@material-ui/core';
import { AlignCenter } from "react-feather";


export default class ComponentToPrint extends React.Component {

  render() {
    const groups = this.props.groups;
    const generalJournal = this.props.generalJournal;
    const factories = this.props.factories;
    const transactionModes = this.props.transactionModes;
    const accountTypeNames = this.props.accountTypeNames;
    const selectedDate = this.props.selectedDate;
    const journalData = this.props.journalData;

    let totalCredit = 0;
    let totalDebit = 0;
    journalData.forEach(x => {
      totalCredit += x.credit
      totalDebit += x.debit
    });

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div
          style={{
            fontFamily: 'sans-serif',
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="record-container"
        >
          <div className="table-responsive row-top-gap">
            <div style={{ fontSize: "14px" }}>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{groups[generalJournal.groupID]}</p>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{factories[generalJournal.factoryID]}</p>
              <p style={{ textAlign: 'center', fontSize: "12px" }}>
                {generalJournal.transactionMode == 1 ? 'MAIN CASH PAYMENT VOUCHER' :
                  generalJournal.transactionMode == 2 ? 'GENERAL CASH PAYMENT VOUCHER' :
                    generalJournal.transactionMode == 3 ? 'CHEQUE PAYMENT VOUCHER' :
                      generalJournal.transactionMode == 7 ? 'TRANSFER PAYMENT VOUCHER' : ""
                }
              </p>
            </div>
            &nbsp;
            <Grid container style={{ fontSize: "14px" }}>
              <Grid container xs={8}>
                <Grid item xs={4}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "50px" }}
                  >
                    <p>Recipient</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>Description</p>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "50px" }}
                  >
                    <p>{generalJournal.recipientName}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px", fontSize: "14px" }}
                  >
                    <p>{journalData.length != 0 ? journalData[0].description : ""}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid container xs={4}>
                <Grid xs={6}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>V : NO</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>Date</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>CHQ No</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>Created Date</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>Due Date</p>
                  </div>
                </Grid>

                <Grid xs={6}>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{generalJournal.referenceNumber}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{(selectedDate).split('T')[0]}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{generalJournal.chequeNumber ? (generalJournal.chequeNumber) : "-"}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{(generalJournal.createdDate).split('T')[0]}</p>
                  </div>
                  <div
                    className="col"
                    align={"left"}
                    style={{ paddingBottom: "7px" }}
                  >
                    <p>{generalJournal.dueDate ? (generalJournal.dueDate).split('T')[0] : "-"}</p>

                  </div>

                </Grid>
              </Grid>
            </Grid>
            <div>&nbsp;</div>
            <div></div>
            <Box>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell align={'left'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Acc Code</TableCell>
                      <TableCell align={'left'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Account Name</TableCell>
                      <TableCell align={'center'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Dr</TableCell>
                      <TableCell align={'center'}
                        style={{
                          border: "1px solid black",
                          padding: "2px",
                          fontSize: "12px",
                        }}
                      >Cr</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ borderBottom: '1px solid black' }}>
                    {journalData.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.selected[0].ledgerAccountCode}
                        </TableCell>
                        <TableCell align={'left'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.selected[0].ledgerAccountName}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.debit != 0 ? Number(data.debit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                        </TableCell>
                        <TableCell align={'right'} scope="row" style={{ borderBottom: "none", borderLeft: '1px solid black', borderRight: '1px solid black', fontSize: '12px', padding: "2px" }}>
                          {data.credit != 0 ? Number(data.credit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ fontSize: "12px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell style={{ fontSize: "12px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: "2px" }}>
                        {totalDebit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'right'} scope="row" style={{ border: "1px solid black", fontSize: "12px", padding: "2px" }}>
                        {totalCredit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            &nbsp;
            <div
              align={"left"}
              style={{ fontSize: "14px", paddingBottom: '50px' }}
            >
              <p>I do hereby certify that I have paid Sum of Rupees <b>{totalCredit.toFixed(2)}</b> Only as<b /> detailed above from the management of {factories[generalJournal.factoryID]}.</p>
            </div>
            <div style={{ paddingBottom: "10px", fontSize: "14px" }} align={"right"}>
              Signature of Receipient
            </div>
            &nbsp;
            &nbsp;
            <Grid container style={{ fontSize: '14px' }}>
              <Grid item xs={4} align='left'>
                <div
                  className="row"
                  align={"left"}
                >
                  Prepaired By
                </div>
              </Grid>
              <Grid item xs={4} align='left'>
                <div
                  className="row"
                  align={"left"}
                >
                  Checked By
                </div>
              </Grid>
              <Grid item xs={4} align='left'>
                <div
                  className="row"
                  align={"left"}
                >
                  Aproved By
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Paper>
    );
  }
}
